import { render } from "./homeUserCenter.vue?vue&type=template&id=e1f72e9c&scoped=true"
import script from "./homeUserCenter.vue?vue&type=script&lang=js"
export * from "./homeUserCenter.vue?vue&type=script&lang=js"

import "./homeUserCenter.vue?vue&type=style&index=0&id=e1f72e9c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f72e9c"]])

export default __exports__